<section class="service_plan" id="content" *ngIf="lang">
  <div class="page page-profile">

    <!-- page header -->
    <div class="pageheader">
      <h2>{{ lang?.maintenancePlans }}</h2>
      <div class="page-bar">
        <ul class="page-breadcrumb">
          <li>
            <a [routerLink]="'/'+AppFrontRoutes.DASHBOARD"><i class="fa fa-home"></i>
              {{AppSettings.SITE_TITLE | titlecase}}</a>
          </li>
          <li>
            <a [routerLink]="'/'+AppFrontRoutes.MAINTENANCE_PLANS">{{ lang?.servicing }}
            </a>
          </li>

          <li>
            <a>{{ lang?.maintenancePlans }}
            </a>
          </li>
        </ul>
      </div>
    </div>

    <!-- page content -->
    <div class="pagecontent">

      <!-- row -->
      <div class="row">
        <div class="col-md-12">
          <div class="tile tile-simple">

            <!-- tile body -->
            <div class="tile-body" [ngSwitch]="pageView">
              <div role="tabpanel" *ngSwitchCase="'list'">

                <!-- Nav tabs -->

                <div class="tab-content">

                  <div role="tabpanel" class="tab-pane active" id="listTab">
                    <div class="row p-10">

                      <div class="col-sm-3" style="width: 20%;">
                        <div class="social-icons">

                          <a class="plus-add" (click)="addMaintenance()" [ngClass]="(rolepermission=='1')?'overwrite_read':'overwrite_write'" title="Add">
                            <i class="fa fa-plus"></i>
                          </a>

                          <a class="plus-export" data-toggle="modal" data-target="#datatableExport1"
                            data-options="splash-2 splash-ef-4">
                            <span class="glyphicon glyphicon-export" title="Export"></span>
                          </a>


                          <a class="plus-copy" (click)="multiDuplicate()" data-action="show" data-id="" [ngClass]="(rolepermission=='1')?'overwrite_read':'overwrite_write'" title="Duplicate">
                            <span class="glyphicon glyphicon-file"></span>
                          </a>

                          <a class="plus-delete" *ngIf="deleteOption" (click)="multiDelete()" [ngClass]="(rolepermission=='1')?'overwrite_read':'overwrite_write'" title="Erase">
                            <span class="glyphicon glyphicon-trash"></span>
                          </a>

                          <!-- <a href="javascript:history.back()" class="plus-export">
                            <span class="glyphicon glyphicon-arrow-left"></span>  
                          </a> -->

                        </div>
                      </div>

                      <div  class="col-sm-9">
                        <input
                        style="float: right;width: 20%;"
                        #search
                        id="search"
                        type="text"
                        class="form-control"
                        placeholder="Search"
                        aria-label="Search"
                        aria-describedby="basic-addon1"
                      />                        
                      </div>                      

                    </div>

                    <div class="form-group" style="overflow: auto;">
                      <table datatable [dtOptions]="datatableOptions2" class="table-striped table-sm row-border hover"
                        id="table2">
                        <thead>
                          <tr>
                            <th>Hidden.No</th>
                            <th>
                              <label class="checkbox checkbox-custom-alt checkbox-custom-sm">
                                <input type="checkbox"><i></i>
                              </label>
                            </th>
                            <th>{{ lang?.sno }}</th>
                            <th>{{ lang?.planCode }}</th>
                            <th>{{ lang?.description }}</th>
                            <th>{{ lang?.repetitions }}</th>
                            <th>{{ lang?.daysnotify }}</th>
                            <th>{{ lang?.notification_time }}</th>
                            <th>{{ lang?.equipment_to_which_the_plan_applies }}</th>
                            <th>{{ lang?.action }}</th>
                          </tr>
                        </thead>
                        <tbody dragula="records" [(dragulaModel)]="records">
                          <tr *ngFor="let record of records let i = index" id="{{record.pk_maintenance_plan_id}}">
                            <td>{{i+1}}</td>
                            <td></td>
                            <td>{{i+1}}</td>
                            <td>{{record.plan_code}}</td>
                            <td>{{record.plan_description}}</td>
                            <td>{{record.how_often_value}} {{record.how_often_frequency}}</td>
                            <td>{{record.days_notify}}</td>
                            <td>{{record.notification_time}}</td>
                            <td><div *ngFor='let equip_val of record.equipment_to_which_pval let k=index'><a [routerLink]="['/'+AppFrontRoutes.SERVICING_VIEW+'/'+equip_val.item_id]" class="blue_action"> {{ k + 1 }}. {{equip_val.item_name}}</a></div><td>

                              <div class="btn-group dropup">

                                <button type="button" class="btn btn-info dropdown-toggle circle_btn"
                                  data-toggle="dropdown" aria-expanded="false"><i class="fa fa-tasks"></i></button>

                                <ul class="dropdown-menu dropdown-menu-right action_btn" role="menu">

                                  <li [ngClass]="(rolepermission=='1')?'overwrite_read':'overwrite_write'"><a class="edit_action" (click)="editMaintenance(record.pk_maintenance_plan_id)"><i
                                        class="fa fa-edit"></i>{{ lang?.modify }}</a></li>

                                  <li [ngClass]="(rolepermission=='1')?'overwrite_read':'overwrite_write'"><a class="delete_action" (click)="delete(record.pk_maintenance_plan_id)"><i
                                        class="fa fa-trash"></i>{{ lang?.erase }}</a></li>
                                </ul>
                              </div>
                            </td>
                          </tr>
                        </tbody>

                      </table>
                    </div>
                  </div>

                </div>

              </div>



              <div role="tabpanel" *ngSwitchCase="'calendar'">

                <div class="row p-10">

                  <div class="col-sm-9">
                  </div>

                  <div class="col-sm-3">
                    <div class="social-icons">
                      <a class="plus-export" (click)="setPageView('list')">
                        <span class="glyphicon glyphicon-list"></span>
                      </a>
                      <a class="plus-export" (click)="setPageView('calendar')">
                        <span class="glyphicon glyphicon-calendar"></span>
                      </a>
                    </div>
                  </div>

                </div>

                <app-servicing-calendar></app-servicing-calendar>
              </div>



            </div>

          </div>
        </div>
      </div>

    </div>
  </div>
</section>


<div class="modal splash fade" id="datatableExport1" tabindex="-1" role="dialog" aria-hidden="true" *ngIf="lang">

  <div class="modal-dialog">
    <div class="modal-content">

      <div class="modal-header">
        <h3 class="modal-title custom-font">{{ lang?.selectColumns }}</h3>
      </div>

      <div class="modal-body column_export">
        <div class="row select-alls">
          <label class="checkbox checkbox-custom-alt checkbox-custom-sm"> <input type="checkbox"
              (change)="export2_select_deselect_all($event)"><i></i>{{lang?.selectAll}}</label>
        </div>
        <div class="row flexs">

          <div class="active-left">
            <h2>Active Columns</h2>

            <div class="row" *ngFor="let option of datatableCols2">
              <label class="checkbox checkbox-custom-alt checkbox-custom-sm">
                <input type="checkbox" value="{{option.id}}" [checked]="option.isSelected" class="col_select1"
                  (change)="export2_select_deselect($event)"><i></i> {{option.value}}
              </label>
            </div>

          </div>

        </div>

      </div>

      <div class="modal-footer">
        <div id="datatableExportBtn2" class="export_dynamic_btn">
        </div>
        <button class="btn btn-warning" data-dismiss="modal">{{ lang?.close }}</button>
      </div>

    </div>
  </div>
</div>